import { createContext, Context } from 'react';

import { IAuthContext } from './interfaces';

export const authContext: Context<IAuthContext> = createContext({
  user: null,
  isAuthenticated: false,
  isAuthenticating: true,
} as IAuthContext);
